import { themes } from '../../ThemeProvider';
import getOr from 'lodash/fp/getOr';
export var createRgba = function (color, alpha) {
    color = getOr(false, "colors[".concat(color, "]"), themes.default) || color;
    if (/^rgb/.test(color)) {
        return "rgba(".concat(color.substring(color.indexOf('(') + 1, color.length - 1), ", ").concat(alpha, ")");
    }
    if (/^#/.test(color)) {
        var r = parseInt("0x".concat(color.substr(1, 2)));
        var g = parseInt("0x".concat(color.substr(3, 2)));
        var b = parseInt("0x".concat(color.substr(5, 2)));
        return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(alpha, ")");
    }
    return color;
};
export default createRgba;
